import { Helmet } from 'react-helmet';

type Props = {
  description: string;
};

export const MetaDescription = ({ description }: Props) => (
  <Helmet>
    <meta content={description} name="description" />
    <meta property="og:description" content={description} />
  </Helmet>
);
